module.exports = {
  copy: require('./copy')
}



//////////////////
// WEBPACK FOOTER
// ./~/fs-promise/~/fs-extra/lib/copy/index.js
// module id = 1301
// module chunks = 0 1 2